export default "__VITE_ASSET__0YiBW_Pm__"